<template>
  <div style="width: 100%; position: relative">
    <a-select
      showSearch
      v-model="localValue"
      placeholder='Enter subscription name'
      style="width: 100%"
      :defaultActiveFirstOption="false"
      :showArrow="false"
      :filterOption="false"
      @search="handleSearch"
      @change="handleChange"
      notFoundContent=""
      @blur="handleBlur"
    >
      <a-select-option v-for="s in subscriptions" :key="s.id">{{ generateName()(s) }}</a-select-option>
    </a-select>
    <a-icon v-if="loadingSubscriptions" type="loading" />
  </div>
</template>

<script>
  import { debounce } from 'lodash'
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'SubscriptionAutocomplete',
    data() {
      return {
        inputValue: ''
      }
    },
    props: ['value', 'onBlur'],
    computed: {
      localValue: {
        get() {
          return this.value
        },
        set(localValue) {this.$emit('input', localValue)}
      },
      ...mapState('newUserForm', ['subscriptions', 'loadingSubscriptions'])
    },
    methods: {
      ...mapActions('newUserForm', ['fetchSubscriptions']),
      ...mapGetters('subscriptions', ['generateName']),
      ...mapMutations('newUserForm', ['startLoadingSubscriptions']),
      handleSearch: function(value) {
        this.inputValue = value
        if(value) this.startLoadingSubscriptions()
        return this.fetchMatches(value)
      },
      fetchMatches: debounce(function(value) {
        if(value) this.fetchSubscriptions(value)
      }, 300),
      handleChange(value) {
        this.localValue = value
      },
      handleBlur() {
        this.onBlur()
      }
    }

  }
</script>

<style scoped lang='stylus'>
  .anticon-loading {
    width: 17px;
    height: 17px;
    position: absolute;
    top: 12px;
    right: 10px;

    svg {
      width: 100%;
      height: 100%;
      fill: $primaryBlue;
    }
  }
</style>
